import { createContext } from 'react';
import EventEmitter from './event-emitter';

/**
 * Provides a React context for an event emitter, so that components can listen for events
 * thrown by components nested deep inside.
 */
const EventEmitterContext = createContext(new EventEmitter());
export default EventEmitterContext;
